module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/Cerrar.02a76dfd.svg";